export const FINANCE_ELEMENT_TYPE_BUDGET = 'Budget';
export const FINANCE_ELEMENT_TYPE_ACTUAL = 'Actual';
export const FINANCE_ELEMENT_TYPE_REMAINING = 'Remaining';
export const FINANCE_ELEMENT_TYPE_FORECAST = 'Forecast';
